import {gunlukZamanlayiciOlustur} from "@/plugins/uyap-plugin/GunlukZamanlayici";

/**
 * Gece senkronu ön-kontrolü zamanlayıcısı (Sorgu Snapshot Faz 3, DEV-2967).
 *
 * Görev Yöneticisi'nden BAĞIMSIZ, ayrı bir modüldür: `GorevYoneticisi.ts` ve
 * `TaskHandler`lar bu işte hiç değişmedi. Zamanlayıcı yalnız SAATİ bilir; ne
 * kontrol edileceğine ve bildirimin nasıl gösterileceğine uygulama karar verir
 * (kanca deseni, `BaglantiKurtarma` ile aynı).
 *
 * Varsayılan saat plan §6-İP6'da 22:45; değerin kendisi uygulamanın ayarından
 * gelir, burada gömülü değildir.
 */

const DEPOLAMA_ANAHTARI = "senkronOnKontrolSonAtesGunu";

let kanca: (() => void | Promise<void>) | null = null;

/**
 * Ön-kontrolü koşacak geri çağrımı kaydeder. Kaydedilmezse zamanlayıcı sessizce
 * hiçbir şey yapmaz — plugin'i kullanan diğer uygulama (vue-imza-app) bu özelliği
 * devreye almadan da çalışmaya devam eder.
 */
export function onKontrolKancasiniAyarla(fn: (() => void | Promise<void>) | null): void {
    kanca = fn;
}

const zamanlayici = gunlukZamanlayiciOlustur({
    depolamaAnahtari: DEPOLAMA_ANAHTARI,
    ateslendiginde: () => {
        if (!kanca) return;
        return kanca();
    }
});

export const SenkronOnKontrolZamanlayici = zamanlayici;
